import type { ReactNode } from "react";

import { LanguageToggle } from "@/components/ui/LanguageToggle";
import { useI18n } from "@/i18n/use-i18n";

/** Centred card on the navy gradient, shared by every unauthenticated screen. */
export function AuthShell({ children }: { children: ReactNode }) {
  const { t } = useI18n();

  return (
    <div className="grid min-h-dvh place-items-center bg-[radial-gradient(1200px_600px_at_50%_-10%,#0a3f8c_0%,var(--color-navy-deep)_55%,#021631_100%)] p-4 sm:p-5.5">
      <div className="w-full max-w-[410px] rounded-[18px] bg-surface px-6 py-8 shadow-modal sm:px-9 sm:py-9.5">
        {/* No white chip needed here: the card is already white, and at this size
            the wordmark inside the logo is legible. */}
        <div className="mb-4.5 flex items-start justify-between gap-4">
          <img
            src="/ai2connectlogo.png"
            alt="AI2Connect"
            width={56}
            height={56}
            className="size-[56px] object-contain"
          />
          {/* The topbar is not mounted on the unauthenticated screens, so
              without this the login page would be stuck in one language. */}
          <LanguageToggle tone="light" />
        </div>

        {children}

        <p className="mt-5 text-center text-[11.8px] text-muted">{t("auth.shellNote")}</p>
      </div>
    </div>
  );
}
